import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

export const firebaseConfig = {
  apiKey: "AIzaSyD0cu4MIkbdsp5U8wCvMYjq8qrdOtIrb4I",
  authDomain: "mst-sports-tours.firebaseapp.com",
  projectId: "mst-sports-tours",
  storageBucket: "mst-sports-tours.firebasestorage.app",
  messagingSenderId: "646765209845",
  appId: "1:646765209845:web:c13276bf21c485d256bdbc"
};

// Local testing only: `REACT_APP_USE_EMULATORS=1 npm start` runs the app against
// the Firebase emulators under a demo project, so nothing can reach live data
// or send real emails. Never set in a build.
const useEmulators = process.env.REACT_APP_USE_EMULATORS === '1';

const app = initializeApp(useEmulators ? { ...firebaseConfig, projectId: 'demo-mst' } : firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
